module.exports = __webpack_public_path__ + "static/img/5.710f857.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/5.png
// module id = IpAW
// module chunks = 1